import {version, Component} from 'inferno';

class Contact extends Component {
    render() {
        return (
            <div className="container languages">
                <div className="columns">
                    <div className="column col-2 col-sm-12 col-md-12 hide-md hide-sm hide-xs" />

                    <div className="column col-4 col-sm-12 col-md-12">
                        <div className="panel bg-white">
                            <div className="panel-body">
                                <h6 className="subtitle">Email</h6>
                                <p>gurpreet@gurpreet.co</p>
                            </div>
                        </div>
                    </div>
                    <div className="column col-4 col-sm-12 col-md-12">
                        <div className="panel bg-white">
                            <div className="panel-body">
                                <h6 className="subtitle">LinkedIn</h6>
                                <a href="https://uk.linkedin.com/in/gurpreetpaul">https://uk.linkedin.com/in/gurpreetpaul</a>
                            </div>
                        </div>
                    </div>

                    <div className="column col-2 col-sm-12 col-md-12 hide-md hide-sm hide-xs" />
                </div>
            </div>
        );
    }
}

export default Contact;
